
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22.471 12.822v-.014h-12.24L9.4 9.9a5.107 5.107 0 019.815-2.82l.751 2.62.019.065a1.19 1.19 0 002.272-.709l-.007-.023-.75-2.609a7.487 7.487 0 00-14.391 4.128l.647 2.256H7.5v.011a2.709 2.709 0 00-2.5 2.7v3.525A9.986 9.986 0 0014.956 29a9.986 9.986 0 009.956-9.956v-3.525a2.711 2.711 0 00-2.441-2.697zM16.016 20.3v3.931a.437.437 0 01-.434.434H14.2a.437.437 0 01-.434-.434V20.3a2.324 2.324 0 112.256 0z","fill":"#222"}})])
          )
        }
      }
    